import React, { useEffect } from 'react';
import './CustomAlert.css';
import logocontalearn from '../imagesHome/logoconta.png';

const CustomAlert = ({ onConfirm, onCancel }) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <div className="duo-alert-overlay">
      <div className="duo-alert-box">
        <img src={logocontalearn} alt="duo" className="duo-mascot" />
        <h2 className="duo-title">Stai, nu pleca!</h2>
        <p className="duo-text">Iti vei pierde progresul daca iesi acum</p>
        <div className="duo-buttons">
          <button className="btn-primary-duo" onClick={onCancel}>Continua sa inveti</button>
          <button className="btn-link-duo" onClick={onConfirm}>Incheie sesiunea</button>
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;
